import { RootState } from "../../RootReducer";

export const selectAuthentication = (state: RootState) => state.authentication;
export const selectAuthenticated = (state: RootState) => state.authentication.authenticated;
